import { useState } from 'react';
import useGetNutritionByPeriod from '../../hooks/data/nutrition/useGetNutritionByPeriod';
import NutritionCharts from '../nutrition/NutritionCharts';
import ErrorMessage from '../ui/ErrorMessage';
import LoadingSpinner from '../ui/LoadingSpinner';
import DiaryPeriodPicker from './DiaryPeriodPicker';

const DiaryNutrition = ({ current_day }) => {
    const urlParams = new URLSearchParams(window.location.search);
    const startParam = urlParams.get('start');
    const endParam = urlParams.get('end');

    const [period, setPeriod] = useState({
        start: startParam ?? current_day,
        end: endParam ?? current_day
    });

    const { data, isLoading, isError, error } = useGetNutritionByPeriod(period.start, period.end);

    if (isError)
        return <ErrorMessage message={error?.message || 'Något gick fel vid hämtning av näringsdata.'} />;

    return (
        <div className="diary-nutrition-content">
            <div className="title-row">
                <h3 className="bold-title">
                    Resultat{' '}
                    <span>
                        ({period.start} - {period.end})
                    </span>
                </h3>
            </div>

            <DiaryPeriodPicker onChange={setPeriod} period={period} />

            {!isLoading ? <NutritionCharts data={data} /> : <LoadingSpinner />}
        </div>
    );
};

export default DiaryNutrition;
